<div class="bems-footer">
  <div class="bems-footer-container row">
    <div class="bems-footer-progress-wrapper d-none d-sm-none d-md-flex col-md-5 col-12" *ngIf="dataHeadTitle==='STATUS'">
      <div style="width: min-content;">
        <img class="footerImgLegend" src="assets/images/LegendP3.png">
        <div class="bems-footer-tooltip-warning ng-binding">{{percent[0] | number:0}}%</div>
        <div class="bems-footer-tooltip-danger ng-binding">{{percent[1] | number:0}}%</div>
      </div>
      <div>
        <p class="bems-footer-progress-text" style="margin-top: 1rem;">
          <span class="title">Total Energy Target</span>
          <br>
          <span class="value ng-binding">{{ overviewData?.total | number:'1.1-1' }}</span>
          <span class="unit">kWh</span>
        </p>
      </div>
    </div>
    <div class="bems-footer-progress-wrapper d-none d-sm-none d-md-flex col-md-5 col-12" *ngIf="dataHeadTitle!=='STATUS'">
    </div>
    <img class="footerImg d-none d-sm-none d-md-block col-md-7 col-12" src="assets/images/cover.png">
  </div>
  <div class="d-none d-sm-none d-md-block" id="footer-b-outter">Copyright 2018 , Chulalongkorn University Building Energy Management System </div>
</div>
